export default __webpack_public_path__ + "static/opening-hours-1aab62bc6e6aaf11b503782c9d93ea72.png";